import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", { class: "govuk-heading-xl" }, "Basket", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", { class: "govuk-heading-l" }, "Summary", -1)
const _hoisted_3 = {
  key: 0,
  class: "govuk-table"
}
const _hoisted_4 = { class: "govuk-table__caption govuk-table__caption--m" }
const _hoisted_5 = { class: "govuk-table__head" }
const _hoisted_6 = { class: "govuk-table__row" }
const _hoisted_7 = ["aria-sort"]
const _hoisted_8 = ["onClick"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("th", {
  scope: "col",
  class: "govuk-table__header"
}, null, -1)
const _hoisted_10 = { class: "govuk-table__body" }
const _hoisted_11 = { class: "govuk-table__cell" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { key: 1 }
const _hoisted_14 = /*#__PURE__*/_createStaticVNode("<div class=\"govuk-inset-text\"> You will have access to the documents you order for 31 days. You will need an account to order and view the documents. You will be asked to either create an account or sign into your account. </div><div class=\"govuk-warning-text\"><span class=\"govuk-warning-text__icon\" aria-hidden=\"true\">!</span><strong class=\"govuk-warning-text__text\"><span class=\"govuk-warning-text__assistive\">Warning</span> The documents are provided for personal use only; you must get the relatives&#39; permission if you want to publish them in any way. </strong></div>", 2)
const _hoisted_16 = ["href", "onClick"]
const _hoisted_17 = { key: 2 }
const _hoisted_18 = ["href", "onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _hoisted_2,
    (_ctx.basketItems)
      ? (_openBlock(), _createElementBlock("table", _hoisted_3, [
          _createElementVNode("caption", _hoisted_4, _toDisplayString(_ctx.numberOfItemsText), 1),
          _createElementVNode("thead", _hoisted_5, [
            _createElementVNode("tr", _hoisted_6, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columns, (column, name) => {
                return (_openBlock(), _createElementBlock("th", {
                  key: name,
                  scope: "col",
                  class: "govuk-table__header",
                  "aria-sort": (_ctx.sortColumn === name ? _ctx.sortDirection : 'none')
                }, [
                  _createElementVNode("button", {
                    onClick: ($event: any) => (_ctx.sortBy(name, 'ascending', column.label)),
                    type: "button"
                  }, _toDisplayString(column.label), 9, _hoisted_8)
                ], 8, _hoisted_7))
              }), 128)),
              _hoisted_9
            ])
          ]),
          _createElementVNode("tbody", _hoisted_10, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.basketItems, (entry, index) => {
              return (_openBlock(), _createElementBlock("tr", {
                class: "govuk-table__row",
                key: index
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columns, (column, name) => {
                  return (_openBlock(), _createElementBlock("td", {
                    key: name,
                    class: "govuk-table__cell"
                  }, _toDisplayString(_ctx.getFormattedColumnValue(entry[name], column.type)), 1))
                }), 128)),
                _createElementVNode("td", _hoisted_11, [
                  _createElementVNode("a", {
                    class: "govuk-link",
                    href: "#",
                    onClick: _withModifiers(($event: any) => (_ctx.removeFromBasket(index)), ["prevent"])
                  }, " Remove from basket ", 8, _hoisted_12)
                ])
              ]))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.getBasketCount > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
          _hoisted_14,
          _createVNode(_component_router_link, {
            to: { name: 'Pay', params: { back: 'Basket' } },
            custom: ""
          }, {
            default: _withCtx(({ href, navigate }) => [
              _createElementVNode("a", {
                href: href,
                onClick: navigate,
                role: "button",
                draggable: "false",
                class: "govuk-button",
                "data-module": "govuk-button"
              }, " Place order ", 8, _hoisted_16)
            ]),
            _: 1
          })
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_17, [
          _createVNode(_component_router_link, {
            to: { name: 'Home' },
            custom: ""
          }, {
            default: _withCtx(({ href, navigate }) => [
              _createElementVNode("a", {
                href: href,
                onClick: navigate,
                role: "button",
                draggable: "false",
                class: "govuk-button",
                "data-module": "govuk-button"
              }, " Find a will ", 8, _hoisted_18)
            ]),
            _: 1
          })
        ]))
  ], 64))
}